<ng-template #colorCodeCell let-row>
  <div style="display: flex; align-items: center; gap: 6px;">
    <span style="display: inline-block; width: 12px; height: 12px; border-radius: 50%; flex-shrink: 0; border: 1px solid rgba(0,0,0,0.15);"
          [style.background-color]="row.color_code"></span>
    <span style="font-size: 0.875rem;">{{ row.color_code }}</span>
  </div>
</ng-template>

<div [hidden]="viewMode !== 'list'" class="master-container">
  <lib-dynamic-listing
    [module]="config.masterType"
    [columns]="columnConfigs"
    [data]="tableData"
    [actions]="actionConfigs"
    [headerActions]="headerActionConfigs"
    [isLoading]="isLoading"
    [pageIndex]="pageIndex"
    [rowsPerPage]="rowsPerPage"
    [totalCount]="totalCount"
    [totalPages]="totalPages"
    [showIncludeInactiveCheckbox]="true"
    [includeInactive]="showInactives"
    [cellTemplates]="cellTemplates"
    (actionClicked)="onActionClicked($event)"
    (pageChanged)="onPageChanged($event)"
    (includeInactiveChanged)="showInactives = $event; onShowInactivesChange()">
  </lib-dynamic-listing>
</div>
<div [hidden]="viewMode !== 'form'" class="master-form-container">
  <div class="form-content">
    <app-dynamic-form
      [isLoading]="isLoading"
      [data]="formFields"
      [formGroup]="formGroup"
      (fieldChanged)="onFormFieldChanged($event)">
    </app-dynamic-form>

    <div class="form-actions">
      <!-- <button type="button" pButton label="Cancel" severity="secondary" (click)="onCancel()"></button> -->
      <button type="button" pButton [label]="isEditMode ? 'Update' : 'Save'" (click)="onFormSubmit()" [disabled]="isLoading"></button>
    </div>
  </div>
</div>
